import React, { useState } from 'react';
import { HeroSection } from '../../components/HeroSection';
import { Button } from '../../components/ui/Button';
import { ChevronDown, ChevronUp, FileText, Image, Mic, DollarSign } from 'lucide-react';
export function Contribute() {
  const [expandedSection, setExpandedSection] = useState<number | null>(0);
  const guidelines = [{
    icon: <FileText className="h-8 w-8" data-id="element-891" />,
    title: "What We're Looking For",
    content: <div className="space-y-4" data-id="element-892">
          <p className="text-gray-700" data-id="element-893">
            We publish essays, reporting, poetry, visual art, and hybrid forms
            that center fat liberation and justice.
          </p>
          <div className="bg-brand-orange/5 p-4 border-l-4 border-brand-orange" data-id="element-894">
            <h4 className="font-bold mb-2" data-id="element-895">We want work that:</h4>
            <ul className="space-y-2 text-sm" data-id="element-896">
              <li className="flex items-start" data-id="element-897">
                <span className="text-brand-orange mr-2" data-id="element-898">✓</span>
                <span data-id="element-899">Challenges dominant narratives about fat bodies</span>
              </li>
              <li className="flex items-start" data-id="element-900">
                <span className="text-brand-orange mr-2" data-id="element-901">✓</span>
                <span data-id="element-902">Centers fat people's lived experiences</span>
              </li>
              <li className="flex items-start" data-id="element-903">
                <span className="text-brand-orange mr-2" data-id="element-904">✓</span>
                <span data-id="element-905">Engages with theory, history, or political analysis</span>
              </li>
              <li className="flex items-start" data-id="element-906">
                <span className="text-brand-orange mr-2" data-id="element-907">✓</span>
                <span data-id="element-908">Takes risks formally or conceptually</span>
              </li>
              <li className="flex items-start" data-id="element-909">
                <span className="text-brand-orange mr-2" data-id="element-910">✓</span>
                <span data-id="element-911">Shows craft and attention to language</span>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-4 border-l-4 border-gray-300" data-id="element-912">
            <h4 className="font-bold mb-2" data-id="element-913">We're not looking for:</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-914">
              <li className="flex items-start" data-id="element-915">
                <span className="mr-2" data-id="element-916">✗</span>
                <span data-id="element-917">101-level explainers for thin audiences</span>
              </li>
              <li className="flex items-start" data-id="element-918">
                <span className="mr-2" data-id="element-919">✗</span>
                <span data-id="element-920">"Body positivity" or self-love narratives</span>
              </li>
              <li className="flex items-start" data-id="element-921">
                <span className="mr-2" data-id="element-922">✗</span>
                <span data-id="element-923">Work by thin people about their "body image"</span>
              </li>
              <li className="flex items-start" data-id="element-924">
                <span className="mr-2" data-id="element-925">✗</span>
                <span data-id="element-926">Anything that centers weight loss or diet culture</span>
              </li>
            </ul>
          </div>
        </div>
  }, {
    icon: <Image className="h-8 w-8" data-id="element-927" />,
    title: 'Submission Guidelines',
    content: <div className="space-y-4" data-id="element-928">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-929">
            <div data-id="element-930">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-931">
                Essays & Reporting
              </h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-932">
                <li data-id="element-933">
                  <strong data-id="element-934">Length:</strong> 1,500-5,000 words
                </li>
                <li data-id="element-935">
                  <strong data-id="element-936">Format:</strong> .doc or .docx
                </li>
                <li data-id="element-937">
                  <strong data-id="element-938">Include:</strong> Brief bio (50-100 words)
                </li>
                <li data-id="element-939">
                  <strong data-id="element-940">Response time:</strong> 4-6 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-941">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-942">Poetry</h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-943">
                <li data-id="element-944">
                  <strong data-id="element-945">Length:</strong> Up to 5 poems
                </li>
                <li data-id="element-946">
                  <strong data-id="element-947">Format:</strong> .doc or .docx
                </li>
                <li data-id="element-948">
                  <strong data-id="element-949">Include:</strong> Brief bio (50-100 words)
                </li>
                <li data-id="element-950">
                  <strong data-id="element-951">Response time:</strong> 6-8 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-952">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-953">Visual Work</h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-954">
                <li data-id="element-955">
                  <strong data-id="element-956">Format:</strong> High-res JPG or PNG
                </li>
                <li data-id="element-957">
                  <strong data-id="element-958">Include:</strong> Artist statement (200-300 words)
                </li>
                <li data-id="element-959">
                  <strong data-id="element-960">Series:</strong> 5-10 images preferred
                </li>
                <li data-id="element-961">
                  <strong data-id="element-962">Response time:</strong> 4-6 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-963">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-964">
                Hybrid/Experimental
              </h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-965">
                <li data-id="element-966">
                  <strong data-id="element-967">Format:</strong> Varies—contact us first
                </li>
                <li data-id="element-968">
                  <strong data-id="element-969">Include:</strong> Description of form/concept
                </li>
                <li data-id="element-970">
                  <strong data-id="element-971">Examples:</strong> Comics, audio, video essays
                </li>
                <li data-id="element-972">
                  <strong data-id="element-973">Response time:</strong> 6-8 weeks
                </li>
              </ul>
            </div>
          </div>
        </div>
  }, {
    icon: <DollarSign className="h-8 w-8" data-id="element-974" />,
    title: 'Payment & Rights',
    content: <div className="space-y-4" data-id="element-975">
          <div className="bg-brand-orange/10 p-6 border-2 border-brand-orange" data-id="element-976">
            <h4 className="font-bold text-lg mb-3" data-id="element-977">We Pay Our Contributors</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm" data-id="element-978">
              <div data-id="element-979">
                <p className="font-bold text-brand-orange mb-1" data-id="element-980">
                  Essays & Reporting
                </p>
                <p data-id="element-981">$0.25/word (minimum $375)</p>
              </div>
              <div data-id="element-982">
                <p className="font-bold text-brand-orange mb-1" data-id="element-983">Poetry</p>
                <p data-id="element-984">$100 per poem</p>
              </div>
              <div data-id="element-985">
                <p className="font-bold text-brand-orange mb-1" data-id="element-986">Visual Work</p>
                <p data-id="element-987">$200-500 depending on scope</p>
              </div>
              <div data-id="element-988">
                <p className="font-bold text-brand-orange mb-1" data-id="element-989">Hybrid Forms</p>
                <p data-id="element-990">Negotiated based on project</p>
              </div>
            </div>
          </div>
          <div className="prose prose-sm" data-id="element-991">
            <h4 className="font-bold" data-id="element-992">Rights & Licensing</h4>
            <p className="text-gray-700" data-id="element-993">
              We purchase first serial rights. You retain copyright and can
              republish your work elsewhere after 90 days. We ask that you
              credit ReGrowth as the original publisher.
            </p>
            <h4 className="font-bold mt-4" data-id="element-994">Payment Timeline</h4>
            <p className="text-gray-700" data-id="element-995">
              Payment is issued within 30 days of publication via PayPal, Venmo,
              or check. International contributors: we can accommodate various
              payment methods.
            </p>
          </div>
        </div>
  }, {
    icon: <Mic className="h-8 w-8" data-id="element-996" />,
    title: 'Editorial Process',
    content: <div className="space-y-4" data-id="element-997">
          <p className="text-gray-700" data-id="element-998">
            We believe in collaborative editing. If we accept your piece, here's
            what to expect:
          </p>
          <div className="space-y-6" data-id="element-999">
            <div className="flex gap-4" data-id="element-1000">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-1001">
                1
              </div>
              <div data-id="element-1002">
                <h4 className="font-bold mb-1" data-id="element-1003">Acceptance & Contract</h4>
                <p className="text-sm text-gray-700" data-id="element-1004">
                  We'll send you a contract outlining payment, timeline, and
                  rights. Sign and return within 2 weeks.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-1005">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-1006">
                2
              </div>
              <div data-id="element-1007">
                <h4 className="font-bold mb-1" data-id="element-1008">Developmental Edit</h4>
                <p className="text-sm text-gray-700" data-id="element-1009">
                  Your editor will send big-picture feedback on structure,
                  argument, and development. You'll have 2-3 weeks to revise.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-1010">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-1011">
                3
              </div>
              <div data-id="element-1012">
                <h4 className="font-bold mb-1" data-id="element-1013">Line Edit</h4>
                <p className="text-sm text-gray-700" data-id="element-1014">
                  We'll work on language, clarity, and flow. This is a
                  collaborative process—we'll discuss changes with you.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-1015">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-1016">
                4
              </div>
              <div data-id="element-1017">
                <h4 className="font-bold mb-1" data-id="element-1018">Copyedit & Fact-Check</h4>
                <p className="text-sm text-gray-700" data-id="element-1019">
                  Our copyeditor will check grammar, style, and facts. You'll
                  review and approve final changes.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-1020">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-1021">
                5
              </div>
              <div data-id="element-1022">
                <h4 className="font-bold mb-1" data-id="element-1023">Publication</h4>
                <p className="text-sm text-gray-700" data-id="element-1024">
                  We'll schedule your piece and promote it across our channels.
                  You'll receive payment within 30 days.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-4 border-l-4 border-brand-orange mt-6" data-id="element-1025">
            <p className="text-sm text-gray-700" data-id="element-1026">
              <strong data-id="element-1027">Timeline:</strong> From acceptance to publication
              typically takes 2-4 months, depending on the piece and our
              editorial calendar.
            </p>
          </div>
        </div>
  }];
  return <div className="min-h-screen bg-brand-cream" data-id="element-1028">
      <HeroSection title="Contribute / Write With Us" subtitle="We're always looking for fat writers, artists, and thinkers to join our pages." tag="The Digital Publication" bgColor="orange" data-id="element-1029" />

      {/* Introduction */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-1030">
        <div className="prose prose-lg" data-id="element-1031">
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-1032">
            The Digital Publication exists because of{' '}
            <strong className="text-brand-orange" data-id="element-1033">
              fat people's creativity, intellect, and courage
            </strong>
            . We want to publish your work—whether you're an established writer
            or this is your first time submitting.
          </p>
          <p className="text-lg text-gray-600 mt-4" data-id="element-1034">
            We especially encourage submissions from fat Black, Indigenous,
            disabled, trans, and working-class writers.
          </p>
        </div>
      </section>

      {/* Accordion Guidelines */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-1035">
        <div className="space-y-4" data-id="element-1036">
          {guidelines.map((section, index) => <div key={index} className="border-2 border-brand-black bg-white" data-id="element-1037">
              <button onClick={() => setExpandedSection(expandedSection === index ? null : index)} className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1038">
                <div className="flex items-center gap-4" data-id="element-1039">
                  <div className="text-brand-orange" data-id="element-1040">{section.icon}</div>
                  <h3 className="text-xl font-black uppercase text-brand-black text-left" data-id="element-1041">
                    {section.title}
                  </h3>
                </div>
                {expandedSection === index ? <ChevronUp className="h-6 w-6 text-brand-orange flex-shrink-0" data-id="element-1042" /> : <ChevronDown className="h-6 w-6 text-gray-400 flex-shrink-0" data-id="element-1043" />}
              </button>

              {expandedSection === index && <div className="p-6 pt-0 border-t-2 border-gray-100" data-id="element-1044">
                  {section.content}
                </div>}
            </div>)}
        </div>
      </section>

      {/* Submit CTA */}
      <section className="py-20 bg-brand-orange text-white" data-id="element-1045">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1046">
          <h2 className="text-3xl font-black uppercase mb-6" data-id="element-1047">
            Ready to Submit?
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-1048">
            Send your work to submissions@regrowth.com with "SUBMISSION: [Type]"
            in the subject line.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1049">
            <Button color="white" size="lg" data-id="element-1050">
              Email Your Submission
            </Button>
            <Button variant="outline" color="white" size="lg" data-id="element-1051">
              Questions? Contact Us
            </Button>
          </div>
          <p className="text-sm mt-8 opacity-75" data-id="element-1052">
            We read submissions year-round. No simultaneous submissions please.
          </p>
        </div>
      </section>
    </div>;
}